var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWcu4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11649_12028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6538 4.97533C25.1262 4.97533 25.5374 4.62579 25.601 4.14448L25.9967 1.15757C26.0664 0.633269 25.6977 0.15196 25.1738 0.0828015C24.6533 0.0173809 24.1692 0.380932 24.0995 0.905231L23.7038 3.89215C23.6341 4.41645 24.0028 4.89775 24.5267 4.96691C24.5692 4.97252 24.6117 4.97533 24.6538 4.97533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6766 5.15578C18.7981 5.15578 18.9219 5.13242 19.0416 5.08289C19.5299 4.88102 19.7626 4.32214 19.5607 3.83335L18.4103 1.04924C18.2084 0.560456 17.6505 0.327746 17.1603 0.53055C16.6719 0.732419 16.4392 1.2913 16.6411 1.78008L17.7916 4.5642C17.9439 4.93335 18.3005 5.15578 18.6766 5.15578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9995 22.4971C25.9997 22.4971 29.244 19.2624 29.244 15.2621C29.244 11.2618 25.9997 8.01758 21.9995 8.01758C17.9992 8.01758 14.7549 11.2618 14.7549 15.2621C14.7549 19.2624 17.9992 22.4971 21.9995 22.4971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9146 7.80689C30.2018 7.80689 30.4889 7.68247 30.6803 7.43364L32.5177 5.04112C32.8336 4.62961 32.757 4.02669 32.3359 3.70134C31.9148 3.37593 31.3215 3.46209 30.9961 3.87359L29.1586 6.26612C28.8332 6.6872 28.9194 7.29012 29.3309 7.6059C29.5127 7.73989 29.7137 7.80689 29.9146 7.80689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9766 11.501C34.4502 10.745 33.6463 10.2473 32.7371 10.0942C31.828 9.95067 30.9093 10.1708 30.1628 10.7258C30.1149 10.7642 30.0671 10.8024 30.0288 10.8407C30.7465 12.1518 31.1581 13.6639 31.1581 15.2621C31.1581 16.0373 31.0624 16.7933 30.8805 17.5111L36.1441 25.0906L30.67 25.3872H13.3864L7.8549 25.0906L13.1184 17.5111C12.9366 16.7933 12.8409 16.0373 12.8409 15.2621C12.8409 13.6639 13.2524 12.1614 13.9798 10.8503C13.9319 10.8024 13.884 10.7642 13.8362 10.7258C13.0898 10.1708 12.1806 9.95067 11.2618 10.0942C10.3527 10.2473 9.5584 10.745 9.02248 11.501L1.16541 22.7364C0.457232 23.7508 0.0839844 24.9374 0.0839844 26.1624C0.0839844 29.1865 2.35209 31.7418 5.34754 32.1055L12.372 32.9476V46.9678C12.372 47.4941 12.8026 47.9248 13.329 47.9248H30.67C31.1964 47.9248 31.627 47.4941 31.627 46.9678V32.9476L38.6515 32.1055C41.6469 31.7418 43.915 29.1865 43.915 26.1624C43.915 24.9374 43.5418 23.7508 42.8336 22.7364L34.9766 11.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4486 4.92624C10.1232 5.33774 10.1998 5.94066 10.6209 6.26607L13.0134 8.10351C13.1857 8.23751 13.3866 8.30451 13.5876 8.30451C13.8747 8.30451 14.1618 8.17051 14.3532 7.93126C14.669 7.51017 14.5925 6.90725 14.1714 6.5819L11.7884 4.7444C11.3673 4.42863 10.7645 4.50515 10.4486 4.92624Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11649_12028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9626,
    height: 48,
    fill: "white",
    transform: "translate(0.0185547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcu4);
export default __webpack_public_path__ + "static/media/wcu-4.c15222df88e7cbfe95a401c61dc138aa.svg";
export { ForwardRef as ReactComponent };